import { useState } from "react";
import { Table, Space, Button, Tooltip, Popconfirm, Typography } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const { Text } = Typography;

export default function ProveedoresPOTable({ data, loading, onEdit, onDelete, permissionUpdate, permissionDelete }) {

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10
  });

  const handleTableChange = (paginationInfo) => {
    setPagination(paginationInfo);
  };

  const renderTextWrap = (value, width = 220) => (
    <Text
      style={{
        display: "block",
        maxWidth: width,
        whiteSpace: "normal",
        wordBreak: "break-word"
      }}
    >
      {value}
    </Text>
  );

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
      width: 300,
      render: (text) => renderTextWrap(text, 300)
    },
    {
      title: "Identificación",
      dataIndex: "identificacion",
      width: 150
    },
    {
      title: "Dirección",
      dataIndex: "direccion",
      width: 250,
      render: (text) => renderTextWrap(text, 250)
    },
    {
      title: "Acciones",
      width: 120,
      align: "center",
      render: (_, record) => (
        <Space>

          {permissionUpdate && (
            <Tooltip title="Editar">
              <Button
                icon={<EditOutlined />}
                size="small"
                onClick={() => onEdit(record)}
              />
            </Tooltip>
          )}

          {permissionDelete && (
            <Popconfirm
              title="¿Eliminar proveedor?"
              okText="Eliminar"
              cancelText="Cancelar"
              onConfirm={() => onDelete(record)}
            >
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
              />
            </Popconfirm>
          )}

        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="oid"
      columns={columns}
      dataSource={data}
      loading={loading}
      bordered
      size="middle"
      pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total) => `Total ${total} proveedores`
      }}
      onChange={handleTableChange}
      style={{
        borderRadius: 8,
        overflow: "hidden"
      }}
    />
  );
}
